import { ChargingCardDto } from '../../charging-cards/api/dto/charging-cards-dto'

export const MOCK_CHARGING_CARDS: ChargingCardDto[] = [
  {
    userInfo: null,
    created_at: '2025-10-22T09:52:30',
    updated_at: '2025-10-22T09:53:21',
    name: 'E3DC Karte F4BFAACA',
    description: '',
    e_mobility_token: 'f4bfaaca',
    ocpi_token_id: 'd737bc6c-6b79-4b75-91fb-3e3491962bec',
    installation_id: 9372,
    wallboxes: [
      '00141648D96AA301',
      '00141648D96C2701',
      '00141648D96DEF01',
      '00141648D974EB01',
      '00141648D9795C01',
      '00141648D979B301',
      '00141648D96E6501',
      '00141648D96C1A01',
    ],
    card_status: 'ACTIVE',
    expiration_date: null,
  },
]
